export const removeObjectEmptyFields = (obj: object): object => {
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== undefined && value !== null && value !== ''));
};
